module.exports = __webpack_public_path__ + "img/Image7@2x.bb3386ff.jpg";